import { cn } from "@/lib/utils";

export const calendarClassNames = {
  months: "flex flex-col sm:flex-row space-y-2 sm:space-x-4 sm:space-y-0",
  month: "space-y-2",
  caption: "flex justify-center pt-0.5 relative items-center",
  caption_label: "text-sm font-semibold text-white",
  nav: "space-x-1 flex items-center",
  nav_button: cn(
    "h-6 w-6 bg-slate-800 hover:bg-slate-700 rounded-lg p-0 text-slate-400 hover:text-white transition-colors inline-flex items-center justify-center"
  ),
  nav_button_previous: "absolute left-1",
  nav_button_next: "absolute right-1",
  table: "w-full border-collapse",
  head_row: "flex",
  head_cell: "text-slate-500 rounded-md w-8 font-medium text-[0.7rem]",
  row: "flex w-full mt-0.5",
  cell: cn(
    "relative p-0 text-center text-sm focus-within:relative focus-within:z-20",
    "[&:has([aria-selected])]:bg-altiv-navy/10 [&:has([aria-selected])]:rounded-lg"
  ),
  day: cn(
    "h-8 w-8 p-0 font-normal rounded-lg transition-colors text-[0.8rem]",
    "text-slate-300 hover:bg-slate-700 hover:text-white",
    "focus:outline-none focus:ring-2 focus:ring-[#0052FF] focus:ring-offset-1 focus:ring-offset-[#1e293b]",
    "aria-selected:opacity-100"
  ),
  day_range_start: "day-range-start",
  day_range_end: "day-range-end",
  day_selected:
    "bg-altiv-navy text-white hover:bg-altiv-navy hover:text-white focus:bg-altiv-navy focus:text-white",
  day_today: "bg-slate-700 text-white font-semibold",
  day_outside:
    "text-slate-600 opacity-50 aria-selected:bg-altiv-navy/50 aria-selected:text-slate-300",
  day_disabled: "text-slate-600 opacity-30",
  day_range_middle: "aria-selected:bg-altiv-navy/20 aria-selected:text-white",
  day_hidden: "invisible",
};
